import { TASK_PRIORITIES, TaskStatus } from '@/store/tasks/tasks.dto';

/**
 * The Tasks list's status cut, in the vocabulary the list actually presents: the tick box
 * writes exactly these two states, so the filter offers exactly these two — named after
 * the statuses themselves, the way the badge and the task form name them — plus All,
 * which is no status filter at all and therefore does include the states the page has no
 * control for (on hold, canceled, failed) rather than pretending they don't exist.
 */
export type StatusCut = TaskStatus.PENDING | TaskStatus.COMPLETED;

export const STATUS_CUT_OPTIONS: { value: StatusCut; label: string }[] = [
  { value: TaskStatus.PENDING, label: 'Pending' },
  { value: TaskStatus.COMPLETED, label: 'Completed' },
];

/** `filters.status` for a cut. All is an empty list: no `status` param, so every state. */
export const statusCutToFilter = (cut?: StatusCut): string[] => (cut ? [cut] : []);

/** Which cut a `filters.status` reads as; anything wider than one of the two is no cut. */
export const statusCutOf = (status: string[]): StatusCut | undefined => {
  if (status.length !== 1) return undefined;
  if (status[0] === TaskStatus.PENDING) return TaskStatus.PENDING;
  if (status[0] === TaskStatus.COMPLETED) return TaskStatus.COMPLETED;
  return undefined;
};

/** Low / Medium / High, from the one list the pill, the badge and the form all read. */
export const PRIORITY_CUT_OPTIONS = TASK_PRIORITIES.map(({ id, label }) => ({
  value: id as string,
  label,
}));
